import 'lazysizes';
import 'picturefill';

$(document).ready(function () {

    $.each($('.item-card--promo'), function(i,e) {
        var link = $(e).find('a').attr('href');
        $(e).on('click', function(elem) {
            window.location = link;
        });
    });

});


// WEBPACK FOOTER //
// ./app/Resources/assets/default/js/advice/services-apv.js